<template>
  <path
    fill="currentColor"
    d="M1.41421 16.4321L0 15.0179L7.07107 7.94684L13.435 14.3108L17.6777 10.0682L15.9353 8.32578L22.6274 6.53262L20.8343 13.2248L19.0919 11.4824L13.435 17.1392L7.07107 10.7753L1.41421 16.4321Z"
  />
</template>
